<template>
  <v-dialog v-model="newProductModalVisible" max-width="700px" @keydown.enter="addItem" class="ma-0 pa-0">
    <!--<v-btn slot="activator" color="#000000" dark class="add-button mb-2">Lisää tuote</v-btn>-->
    <v-card class="ma-0 pa-0">
      <v-container grid-list-md class="pt-0 pb-0 add-product-container">
        <v-row wrap class="">
          <v-col cols="12" class="mt-3">
            <span class="headline">Lisää tuotetiedot</span>
          </v-col>
          <v-col cols="6">
            <v-text-field 
              v-model="newItem.name.fi" 
              label="Tuotenimi - suomi*" 
              :error-messages="errors.name"
              dense
              hide-details
              autofocus>
            </v-text-field>
          </v-col>
          <!-- <v-col cols="4">
            <v-text-field 
              v-model="newItem.name.en" 
              label="Tuotenimi - englanti" 
              :error-messages="errors.name"
              dense
              hide-details
              autofocus>
            </v-text-field>
          </v-col> -->
          <v-col cols="6">
            <v-text-field 
              v-model="newItem.name.wholesale" 
              label="Tuotenimi - tukkuri" 
              :error-messages="errors.name"
              dense
              hide-details
              autofocus>
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field 
              v-model="newItem.deliveryTime" 
              label="Toimitusaika" 
              required 
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field 
              v-model="newItem.avecorSku" 
              label="Avecor tuotekoodi" 
              persistent-hint 
              hint="Viisinumeroinen." 
              :maxlength="5"
              :counter="true"
              type="number"
              dense>
            </v-text-field>
            <!-- Viimeisin tuotekoodi laskettu valmiiksi. -->
          </v-col>
          <v-col cols="4" class="">
            <v-text-field 
              v-model="newItem.wholesaleSku" 
              label="Tukkurin tuotekoodi" 
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              autocomplete="off"
              label="Tukkuri"
              v-model="newItem.wholesaleCompany"
              :items="getWholesaleCompanies"
              item-text="text"
              item-value="value"
              dense
              hide-details
            />
          </v-col>
          <!--  -->
          <v-col cols="4">
            <v-autocomplete
              autocomplete="off"
              label="Merkkaamot"
              v-model="newItem.printShops"
              :items="getPrintShops"
              placeholder=" "
              item-text="text"
              item-value="value"
              multiple
              dense
              hide-details
            />
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              label="Merkkausformaatit"
              v-model="newItem.printFormats"
              :items="settings.printFormats"
              persistent-hint
              item-text="fi"
              item-value="id"
              multiple
              hide-details
              dense
            />
          </v-col>
          <v-col cols="4" class="text-left py-0">
            <v-checkbox 
              style="margin-top:0px;marging-left:0px;"
              v-model="newItem.warehoused" 
              label="Varastotuote?"
              dense
              hide-details>
            </v-checkbox>
          </v-col>
          <v-col cols="4" class="text-left py-0">
            <v-checkbox 
              style="margin-top:0px;marging-left:0px;"
              v-model="newItem.isPrintProduct" 
              label="Merkkaustuote?"
              dense
              hide-details>
            </v-checkbox>
          </v-col>
          <v-col cols="4" class="text-left py-0">
            <v-checkbox 
              style="margin-top:0px;"
              v-model="newItem.isDoubleSidePrintPossible" 
              label="2-puoli merkkaus?"
              dense
              hide-details>
            </v-checkbox>
          </v-col>
          <v-col cols="12" class="pt-4">
            <v-textarea 
              single-line 
              rows=2
              :auto-grow="true" 
              v-model="newItem.officeComments" 
              dense 
              label="Office tuotekommentit" 
              hide-details>
            </v-textarea>
          </v-col>
          
          <!-- VARIAATIO -->
          <v-col cols="12" class="">
            <span class="headline">Lisää variaation tiedot</span>
          </v-col>
          <v-col cols="3" class="">
            <v-text-field 
              v-model="newProductVariation.wholesaleSku" 
              label="Tukkurin variaatiokoodi" 
              required
              dense
              hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="3" class="">
            <v-autocomplete
              label="Lavapaikka"
              autocomplete="off"
              v-model="newProductVariation.shelfLocation"
              :items="settings.shelfLocationArray"
              multiple
              persistent-hint
              dense
              hide-details
            />
          </v-col>
          
          <v-col cols="3" class="">
            <v-autocomplete
              label="Paketin tyyppi"
              autocomplete="off"
              :items="getPackageTypes"
              v-model="newProductVariation.packageType"
              persistent-hint
              item-text="fi"
              item-value="id"
              dense
              hide-details
            />
          </v-col>
          <v-col cols="3" class="">
            <v-autocomplete
              label="Väri"
              autocomplete="off"
              :items="getColors"
              v-model="newProductVariation.colorCode"
              persistent-hint
              item-text="name"
              item-value="id"
              dense
              hide-details
            />
          </v-col>
          <v-col cols="3" class="">
            <v-autocomplete
              label="Sukupuoli"
              autocomplete="off"
              :items="getGenders"
              v-model="newProductVariation.gender"
              persistent-hint
              item-text="fi"
              item-value="id"
              dense
              hide-details
            />
          </v-col>
          <v-col cols="3" class="">
            <v-text-field
              label="Materiaali"
              v-model="newProductVariation.material"
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="3" class="">
            <v-text-field
              label="Koko"
              v-model="newProductVariation.size"
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="3" class="">
            <v-text-field
              label="Muu variaatio"
              v-model="newProductVariation.other"
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="">
            <v-textarea
              label="Variaation Lisätiedot"
              rows=1
              :auto-grow="true"
              v-model="newProductVariation.additionalInfo"
              dense
              hide-details
            ></v-textarea>
          </v-col>

          <v-col cols="3" class="">
            <v-text-field
              label="Ilman painatusta hinta"
              v-model="newProductVariation.unitPurchasePrice"
            ></v-text-field>
          </v-col>
          <v-col cols="3" class="">
            <v-text-field
              label="Pientilauslisä"
              v-model="newProductVariation.smallOrderExtra"
            ></v-text-field>
          </v-col>
          <v-col cols="2" class="">
            <v-text-field
              label="Pientilausraja"
              v-model="newProductVariation.smallOrderLimit"
            ></v-text-field>
          </v-col>
          <v-col cols="2" class="">
            <v-text-field
              label="Minimi tilaus"
              v-model="newProductVariation.minimumOrderQuantity"
            ></v-text-field>
          </v-col>
          <v-col cols="2" class="">
            <v-text-field
              label="Hinta/painatusväri"
              v-model="newProductVariation.unitPrintColorPrice"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions class="pb-4">
        <v-spacer></v-spacer>
        <v-btn color="avecor-button-global add-button mb-2 mr-1"  small @click="close">Peruuta</v-btn>
        <v-btn color="avecor-button-global add-button mb-2"  small @click="addItem" >Lisää</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapFields } from 'vuex-map-fields'

export default {
    props:[],
    data: () => ({
      autogrow:true,
      editedIndex: -1,
      newItem: {
        warehoused:false,
        archived:false,
        name: {
          fi: '',
          en:'',
          wholesale:''
        },
        avecorSku:'',
        wholesaleSku:'',
        printFormats:[],
        deliveryTime:'',
        isPrintProduct: false,
        isDoubleSidePrintPossible: false,
        productTags: [],
        wholesaleCompany: '',
        printShops:[],
        officeComments:''
      },
      defaultItem: {
        warehoused:false,
        archived:false,
        name: {
          fi: '',
          en:'',
          wholesale:''
        },
        avecorSku:'',
        wholesaleSku:'',
        printFormats:[],
        deliveryTime:'',
        isPrintProduct: false,
        isDoubleSidePrintPossible: false,
        productTags: [],
        wholesaleCompany:'',
        printShops:[],
        officeComments:''
      },
      newProductVariation: {
        archived:false,
        sku: '',
        color: '',
        colorCode:'',
        packageType: '',
        shape:'',
        gender: '',
        material: '',
        other:'',
        deliveryTime: '',
        smallOrderLimit: 0,
        smallOrderExtra: 0,
        minimumOrderQuantity: 10,
        unitPurchasePrice: 0,
        unitPrintColorPrice: 'ei asetettu',
        printLocation:'',
        firstPrintColorIncluded: true,
        chargePerPrintColor: true,
        additionalInfo: '',
        stock:'ei asetettu'
      },
      defaultProductVariation: {
        archived:false,
        sku: '',
        color: '',
        colorCode:'',
        packageType: '',
        shape:'',
        gender: '',
        material: '',
        other:'',
        deliveryTime: '',
        smallOrderLimit: 0,
        smallOrderExtra: 0,
        minimumOrderQuantity: 10,
        unitPurchasePrice: 0,
        unitPrintColorPrice: 'ei asetettu',
        printLocation:'',
        firstPrintColorIncluded: true,
        chargePerPrintColor: true,
        additionalInfo: '',
        stock:'ei asetettu'
      },
      errors:{
        name:''
      }
       
    }),
    watch: {
      newProductModalVisible:{
        handler(val) {
          if(val){
            var highestProductNumber = 0
            Object.keys(this.products).forEach(key => {
              var p = this.products[key]
              var avecorSku = p.avecorSku ? p.avecorSku.toString() : ''
              avecorSku = avecorSku.trim()
              if(avecorSku && !isNaN(Number(avecorSku))){
                var num = Number(p.avecorSku)
                if (num > highestProductNumber) highestProductNumber = num
              }
            })
            this.newItem.avecorSku = highestProductNumber + 1
            console.log(highestProductNumber)
          }
        }
      },
    },
    mounted() {
      
    },

    computed: {
      getColors(){
        var colors = Object.keys(this.settings.colors).map(id => {
          var color = this.settings.colors[id]
          return {...color, name:color.fi + ' ('+color.id+')'}
        })
        return colors.sort((a,b)=>{
          var nameA= a.fi.toLowerCase(), nameB=b.fi.toLowerCase();
          if (nameA > nameB) {
            return 1;
          }
          if (nameB > nameA) {
            return -1;
          }
          return 0;
        })
      },
      getGenders(){
        var genders = this.settings.genders
        return Object.keys(this.settings.genders).reduce(function(result, key) {
          result.push({...genders[key]});
          return result;
        }, []);
      },
      getPrintShops(){
        var printShops = this.printShops
        return Object.keys(this.printShops).map(function(key, index) {
          var p = printShops[key]
          return {text: p.name, value: p.id}
        })
      },
      getPackageTypes(){
        var packageTypes = this.settings.packageTypes
        return Object.keys(this.settings.packageTypes).reduce(function(result, key) {
          result.push({...packageTypes[key]});
          return result;
        }, []);
      },
      getWholesaleCompanies(){
        var companies = []
        var wholesaleCompanies = this.wholesaleCompanies
        Object.keys(this.wholesaleCompanies).forEach(function(key, index) {
          var c = wholesaleCompanies[key]
          //companies.push({text: c.wholesaleCode+'-'+c.name, value: c.id})
          companies.push({text: c.name, value: c.id})
        })
        return companies.sort((a,b)=>{
          var nameA = a.text.trim().toLowerCase(), nameB = b.text.trim().toLowerCase();
          if (nameA > nameB) {return 1;}
          else if (nameB > nameA) {  return -1;}
          return 0;
        })
      },
      
      ...mapFields({
        settings:"settings",
        products:"product.products",
        printShops:"printShop.printShops",
        wholesaleCompanies:"wholesaleCompany.wholesaleCompanies",
        newProductModalVisible:"modals.product.new.visible",
        selectedProductIdInProducts:"views.products.selectedProduct.productId",
      })
    },
    created () {},
    methods: {
      customFormatter(date) {
        var da = dateFormat(date, "yyyy-mm-dd")
        return da
      },
      close () {
        this.newProductModalVisible = false
        setTimeout(() => {
          this.newItem = Object.assign({}, this.defaultItem)
          this.newProductVariation = Object.assign({}, this.defaultProductVariation)
          this.editedIndex = -1
        }, 300)
      },
      async addItem () {
        if(this.newItem.name.fi === '') {alert("Täytä nimi"); return}
        var t = this
        var {warehoused,avecorSku,...y} = this.newItem;
        const newProductId = await this.$store.dispatch('product/set', {...y,avecorSku:avecorSku+'',warehoused}).then(async v => {
          t.selectedProductIdInProducts = null
          setTimeout(() => {t.selectedProductIdInProducts = v}, 1000);
          var {...z} = this.newProductVariation;
          console.log(z)
          const newId = await this.$store.dispatch('productVariation/set', {...z, productId:v,warehoused}).then(v => {
            t.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Lisätty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          })
        })

        this.close()
      },
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/AddProduct.vue